import { visitableHttpUrl } from "@/utils/formatters";

type Props = {
  url: string;
  title?: string;
};

export default function LiveEvaluationBrowserChrome({ url, title }: Props) {
  const href = visitableHttpUrl(url);
  const chromeClass =
    "min-w-0 flex-1 truncate rounded-md border border-gray-200 bg-white px-3 py-1 text-xs text-gray-600";

  return (
    <div className="flex items-center gap-3 border-b border-gray-200 bg-gray-100 px-3 py-2">
      <div className="flex gap-1.5" aria-hidden="true">
        <span className="h-2.5 w-2.5 rounded-full bg-red-400" />
        <span className="h-2.5 w-2.5 rounded-full bg-amber-400" />
        <span className="h-2.5 w-2.5 rounded-full bg-green-400" />
      </div>
      {href ? (
        <a
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          className={`${chromeClass} hover:text-primary hover:underline`}
        >
          {url}
        </a>
      ) : (
        <div className={chromeClass}>{url}</div>
      )}
      {title ? <span className="hidden text-xs text-gray-400 sm:inline">{title}</span> : null}
    </div>
  );
}
